import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

const ignoredSamplingUrls = ['localhost', 'mixpanel'];

if (!Sentry.isInitialized()) {
  Sentry.init({
    release: process.env.GATSBY_COMMIT_ID,
    dsn: process.env.GATSBY_SENTRY_DSN,
    environment: process.env.GATSBY_ENV_LEVEL || 'dev',
    tracesSampler: (samplingContext) => {
      const traceLocation = samplingContext.location?.toString();
      if (
        ignoredSamplingUrls.some((ignoredSamplingUrl) =>
          traceLocation?.includes(ignoredSamplingUrl),
        )
      ) {
        return false;
      }
      return samplingContext.attributes?.['sentry.sample_rate'] ?? true;
    },
    integrations: [
      Sentry.replayIntegration(),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],

    // Disabling sentry traces for now, as it is not needed
    tracesSampleRate: 0,

    // Disabling sentry replays for now, as it is not needed
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });
}
